import VillaShortDetails from './VillaShortDetails';

export default VillaShortDetails;
